
import { defineComponent, ref, computed } from "vue";
import moment from "moment";
export const statusTagDefault =  ref({
      "new": {
        label:"Mới",
        state: "primary",
      },
      "processing": {
        label:"Chưa hoàn tất",
        state: "warning",
      },
      "verified": {
        label:"Đã xác thực",
        state: "success",
      },
      "reviewing": {
        label:"Đang xem xét",
        state: "info",
      },
      "rejected": {
        label:"Không hợp lệ",
        state: "danger",
      },
      "denied": {
        label:"Từ chối",
        state: "danger",
      },
      
    })
export default defineComponent({
  name: "customer-details",
  props: {
      dataCustomer: Object,
  },
  components: {
    
  },
  setup(props) {
    // KHÔNG mutate prop + không format ngày vô điều kiện (null/format-lại-lần-2 -> "Invalid date")
    const data = computed(() => (props.dataCustomer as any) || {});
    const dobText = computed(() => {
      const v = (props.dataCustomer as any)?.dateOfBirth;
      if (!v) return "—";
      const m = moment(v, [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY"] as any);
      return m.isValid() ? m.format("DD/MM/YYYY") : "—";
    });
    // Giá trị trống -> '—' cho đồng bộ chuẩn view
    const fmt = (v: any) => (v == null || String(v).trim() === "" ? "—" : v);
    // Ghép địa chỉ/trường lớp: bỏ phần rỗng, không còn "- ," lơ lửng
    const joinParts = (arr: any[]) => {
      const s = (arr || [])
        .filter((x) => x != null && String(x).trim() !== "" && String(x).trim() !== "-")
        .join(", ");
      return s || "—";
    };
    const statusTag =  ref(statusTagDefault)

    return {
        statusTag,
        data,
        dobText,
        fmt,
        joinParts,
    };
  },
});
